import React, { useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux'


import BranchTable from '../../components/mastersComponents/branch/branchTable'
import AddModal from '../../components/modals/addModal'
import AddBranchModal from '../../components/mastersComponents/branch/addBranchModal'

//Actions
import { createBranch } from '../../redux/actions/branchMasterActions'

function Branch(props) {
    const [searchValue, setSearchValue] = useState('')
    const [modalOpen, setmodalOpen] = useState(false)

    const { createBranch } = props

    const handleSearch = (e, data) => {
        setSearchValue(data.value)
    }

    const handleNewPopup = () => {
        setmodalOpen(true);
    }
    
    return (
        <React.Fragment>
            <div className="ag=theme-material agOver">
                <BranchTable handleSearch={handleSearch} searchValue={searchValue} newPopup={handleNewPopup} />
            </div>
            <AddModal onClose={() => setmodalOpen(false)} open={modalOpen} size='small'>
                <Modal.Header>New Branch</Modal.Header>
                <AddBranchModal 
                    handleCloseAdd={() => setmodalOpen(false)} 
                    createBranch={createBranch}
                />
            </AddModal>
        </React.Fragment>
    )
}


export default connect(null, { createBranch })(Branch)